// extracted by mini-css-extract-plugin
export default {"root":"AudioEditor_root__vCS1V","rootWithHeader":"AudioEditor_rootWithHeader__U6pzI","container":"AudioEditor_container__7RWBh","leftSection":"AudioEditor_leftSection__xzxFH"};